import React, { useRef, useState } from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import { Controller, FreeMode, Navigation, Thumbs } from "swiper/modules";
// Import Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";

import "../awards.css";

// Import required modules

import { useTranslation } from "react-i18next";

export default function SwiperComponent() {
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const { t } = useTranslation("about");

  const [firstSwiper, setFirstSwiper] = useState(null);
  const [secondSwiper, setSecondSwiper] = useState(null);

  return (
    <div className="awards-slider-container">
      <Swiper
        style={{
          "--swiper-navigation-color": "#fff",
          "--swiper-pagination-color": "#fff",
        }}
        loop={true}
        spaceBetween={10}
        navigation={true}
        thumbs={{ swiper: thumbsSwiper }}
        modules={[FreeMode, Navigation, Thumbs]}
        className="award-slider"
        slidesPerView={1}
      >
        <SwiperSlide>
          <div className="award-slider-item">
            <img src="/Award_1.jpeg"  className="awd-img" alt={t("award_desc_four")} />
            <div className="position-absolute bottom-0 left-0 p-4 image-overlay-content">
              {t("award_desc_four")}
            </div>
          </div>
        </SwiperSlide>
        {/* <SwiperSlide>
          <img src="/news-1.png" />
          <div className="position-absolute bottom-0 left-0 p-4 image-overlay-content">
            {t("award_desc_one")}
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <img src="/news-2.png" />
          <div className="position-absolute bottom-0 left-0 p-4 image-overlay-content">
            {t("award_desc_two")}
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <img src="/news-4.png" />
          <div className="position-absolute bottom-0 left-0 p-4 image-overlay-content">
            {t("award_desc_three")}
          </div>
        </SwiperSlide> */}
      </Swiper>
    </div>
  );
}
